import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GtbuySpreadsheetArticle from "../pages/article-gtbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/gtbuy-spreadsheet-guide",
    element: <GtbuySpreadsheetArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;